import { on } from "./on";
export const PLUGIN_NAME = "on";
export const PLUGIN_FACTORY = on;
/**
 * Helper method to register the on Plugin with a Jet.js instance
 */
export const register = (jetjs, opts) => {
    // register plugin
    jetjs.registerPlugin(PLUGIN_NAME, PLUGIN_FACTORY);
    // return if aliases should be ignored
    if (opts !== undefined && opts.alias === false) {
        return;
    }
    jetjs.registerPluginAlias("onClick", "on", {
        event: "click"
    });
};
//# sourceMappingURL=index.js.map